import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getReportsFinanceByDestination: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_DESTINATION].GET_REPORTS_FINANCE_BY_DESTINATION,
	},
}
